import React, { useState } from "react";
import Context from "../../../../context";
import {
  CustomView,
  CustomModal,
  CustomButton2,
  UserInformation,
} from "../../../../components";

import "./index.sass";
import { BLOCK_REASON } from "../../../../values/dropdownItems";
import utils from "../../../../utils";
import { useTranslation } from "react-i18next";

const ShowBlockInfo = () => {
  const { showModal, setShowModal, isLoading, selectedDriver, blockFunction } =
    React.useContext(Context.DriverScreen);

  const [textArea, setTextArea] = useState<string>("");

  const blockInfo = selectedDriver?.blocks[0];

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="driver-approve-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "SHOW_BLOCK_INFO"}
        // label="دلیل مسدود شدن راننده"
      >
        <CustomView.Container className="approve-form-content">
          <CustomView.Row className="block-information-driver">
            <CustomView.Column medium={10}>
              <UserInformation
                avatar={selectedDriver?.avatar}
                name={
                  selectedDriver?.firstName
                    ? selectedDriver?.firstName
                    : selectedDriver?.name
                }
                lastName={
                  selectedDriver?.lastName ? selectedDriver?.lastName : ""
                }
                phoneNumber={
                  selectedDriver?.phoneNumber
                    ? selectedDriver?.phoneNumber
                    : selectedDriver?.telephone
                }
                isBlock={null}
              />
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="block-information-container">
            {blockInfo?.reason && (
              <CustomView.Column className="form-values form-column">
                <label className="form-label">{t("disApproveReason")} :</label>
                <p>
                  {
                    BLOCK_REASON.find(
                      (item) => item.value === blockInfo?.reason
                    )?.name
                  }
                </p>
              </CustomView.Column>
            )}
            {blockInfo?.managerComment && (
              <CustomView.Column className="form-values form-column">
                <label className="form-label">{t("description")} :</label>
                <p>{blockInfo?.managerComment}</p>
              </CustomView.Column>
            )}{" "}
            {blockInfo?.blockDate && (
              <CustomView.Column className="form-values form-column">
                <label className="form-label">{t("blockDate")} :</label>
                <p>
                  {utils.convertGregorianToJalali({
                    date: blockInfo?.blockDate,
                    format: "hh:mm  -  jYYYY/jMM/jDD",
                  })}
                </p>
              </CustomView.Column>
            )}
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default ShowBlockInfo;
